<template>
  <div class="container" >
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-primary btn-lg px-4 me-sm-3"
                @click="iniciar"
                style="margin: auto !important;display: block;">
          Iniciar
        </button>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Home-Component',
  components: {
  },
  data() {
    return {

    }
  },
  created() {
  },
  async mounted() {

  },
  watch: {

  },
  methods: {
    iniciar() {
      this.$router.push({name: 'inicio'})
    }
  }
};
</script>

<style scoped>

</style>
